export const calcTextWidth = (text: string, fontSize: string) => {
  let canvas = document.createElement('canvas');
  let context = canvas.getContext('2d');
  context.font = `${fontSize} -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"`;
  let width = context.measureText(text).width;
  return width;
};
